var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._t("id")],2),_c('div',[_c('div',{style:({ fontWeight: 'bold' })},[_vm._t("inquiry"),_vm._t("multicheckbox"),_vm._t("iconStarred"),_vm._t("iconAnswered")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }